<template>
  <!--
    	作者：wangxw
    	时间：2019-11-05
    	描述：diy组件 客服
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--底边距-->
      <el-form-item label="底边距："><el-slider v-model="curItem.style.bottom" show-input></el-slider></el-form-item>
      <!--右边距-->
      <el-form-item label="右边距："><el-slider v-model="curItem.style.right" show-input></el-slider></el-form-item>
      <!--不透明度-->
      <el-form-item label="不透明度："><el-slider v-model="curItem.style.opacity" show-input></el-slider></el-form-item>
      <!--客服类型-->
      <el-form-item label="客服类型：">
        <el-radio-group v-model="curItem.params.type">
            <el-radio :label="'chat'">在线聊天</el-radio>
            <el-radio :label="'phone'">拨打电话</el-radio>
            <el-radio :label="'ai'">ai</el-radio>

          </el-radio-group>
      </el-form-item>
      <el-form-item label="电话号码：" v-show="curItem.params.type == 'phone'">
        <el-input v-model="curItem.params.phone_num"></el-input>
      </el-form-item>
      <el-form-item label="跳转地址：" v-show="curItem.params.type == 'ai'">
        <div class="d-s-c">
          <div class="url-box flex-1">
            <el-input
              placeholder="请选择跳转地址"
              :value="curItem.params.name + curItem.params.linkUrl"
              readonly
            ></el-input>
          </div>
          <div class="url-box ml10">
            <el-button type="primary" @click="changeLink">选择链接</el-button>
          </div>
        </div>
      </el-form-item>
      <!--客服图标-->
      <el-form-item label="客服图标：">
        <div class="diy-service-icon">
          <img v-img-url="curItem.params.image" alt="" @click="$parent.onEditorSelectImage(curItem.params, 'image')">
        </div>
        <div>建议尺寸90×90</div>
      </el-form-item>
    </el-form>
    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
    >选择链接</Setlink>
  </div>
</template>

<script>
  import Setlink from "@/components/setlink/Setlink";
  export default {
    components:{
      Setlink
    },
    data() {
      return {
        is_linkset:false,
        index:null
      };
    },
    props: ['curItem', 'selectedIndex', 'opts'],
    methods: {
      changeLink(){
        this.is_linkset = true;
      },
      closeLinkset(e) {
        this.is_linkset = false;
        if(e){
          this.curItem.params.linkUrl = e.url;
          this.curItem.params.name = "链接到" + " " +e.type +" "+e.name;
        }
      },
    }
  };
</script>

<style>
.diy-service-icon, .diy-service-icon img{ width: 40px; height: 40px;}
/* 新增链接选择相关样式（复用原轮播图样式） */
.d-s-c {
  display: flex;
  align-items: center;
}
.flex-1 {
  flex: 1;
}
.ml10 {
  margin-left: 10px;
}
.url-box {
  display: flex;
  align-items: center;
}
.url-box .key-name {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Service.vue